// TwinklingStars.js
import React from 'react';
import { Canvas, useFrame } from '@react-three/fiber';
import * as THREE from 'three';

const Stars = () => {
    const ref = React.useRef();
    useFrame(() => {
        if (ref.current) {
            ref.current.rotation.y += 0.001; // Adjust rotation speed
        }
    });

    return (
        <group ref={ref}>
            {Array.from({ length: 2000 }).map((_, index) => { // Increased number of stars
                const x = THREE.MathUtils.randFloatSpread(500); // Increased spread
                const y = THREE.MathUtils.randFloatSpread(500);
                const z = THREE.MathUtils.randFloatSpread(500);
                return (
                    <mesh key={index} position={[x, y, z]}>
                        <sphereGeometry args={[0.2, 8, 8]} /> {/* Increased star size */}
                        <meshBasicMaterial color="white" />
                    </mesh>
                );
            })}
        </group>
    );
};

const TwinklingStars = () => (
    
    <Canvas
        style={{ width: '100%', height: '100%' }}
        camera={{ position: [0, 0, 300], fov: 75 }} // Adjusted camera position
        >
        <ambientLight intensity={0.5} />
        <Stars />
    </Canvas>
);

export default TwinklingStars;
